export var RefundReason = /*#__PURE__*/function (RefundReason) {
  RefundReason["DUPLICATE"] = "Duplicate Account";
  RefundReason["UNSATISFIED"] = "Unsatisfied with Wash";
  RefundReason["DID_NOT_WANT_MEMBERSHIP"] = "Did not want Membership";
  RefundReason["INCORRECT_BILLING"] = "Incorrect Billing";
  RefundReason["WRONG_PLATE"] = "Wrong Plate";
  RefundReason["FORGOT_DISCOUNT"] = "Forgot Discount";
  RefundReason["CUSTOMER_SERVICE"] = "Customer Service Exception";
  RefundReason["OTHER"] = "Other";
  return RefundReason;
}(RefundReason || {});
export var StoreRefundReason = /*#__PURE__*/function (StoreRefundReason) {
  StoreRefundReason["RETURNED_PRODUCT"] = "Returned product";
  StoreRefundReason["UNSATISFIED"] = "Unsatisfied with Wash";
  StoreRefundReason["FORGOT_DISCOUNT"] = "Forgot Discount";
  StoreRefundReason["STORE"] = "Store Exception";
  StoreRefundReason["OTHER"] = "Other";
  return StoreRefundReason;
}(StoreRefundReason || {});
export const StoreRefundReasons = {
  [StoreRefundReason.RETURNED_PRODUCT]: "Returned product",
  [StoreRefundReason.UNSATISFIED]: "Unsatisfied with Wash",
  [StoreRefundReason.FORGOT_DISCOUNT]: "Forgot Discount",
  [StoreRefundReason.STORE]: "Store Exception",
  [StoreRefundReason.OTHER]: "Other"
};
